export default "__VITE_ASSET__s5q5o64l__"